import SuppliersReportAssociate from './SuppliersReportAssociateModal';

export default SuppliersReportAssociate;
